import ImportSource from "../../entities/importSource";

/**
 * ImportSource actions
 *
 * Call order:
 *
 * IMPORTSOURCE_SAVE_QUEUE:	adds the item to the save queue
 * --> IMPORTSOURCE_SAVE:	modifies the state
 * --> IMPORTSOURCE_SAVE_SUCCESS: if all went well
 * --> IMPORTSOURCE_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail IMPORTSOURCE_SAVE_QUEUE is during the call to IMPORTSOURCE_SAVE,
 * as adding an item to the queue should never fail.
 */

export const IMPORTSOURCE_FETCH_ONE_QUEUE: any = 'IMPORTSOURCE_FETCH_ONE_QUEUE';
export const IMPORTSOURCE_FETCH_SUCCESS: any = 'IMPORTSOURCE_FETCH_SUCCESS';
export const IMPORTSOURCE_FETCH_FAILURE: any = 'IMPORTSOURCE_FETCH_FAILURE';
export const IMPORTSOURCE_FETCH_ONE_SUCCESS: any = 'IMPORTSOURCE_FETCH_ONE_SUCCESS';
export const IMPORTSOURCE_FETCH_ONE_FAILURE: any = 'IMPORTSOURCE_FETCH_ONE_FAILURE';

export const IMPORTSOURCE_SAVE: any = 'IMPORTSOURCE_SAVE';
export const IMPORTSOURCE_SAVE_QUEUE: any = 'IMPORTSOURCE_SAVE_QUEUE';
export const IMPORTSOURCE_SAVE_SUCCESS: any = 'IMPORTSOURCE_SAVE_SUCCESS';
export const IMPORTSOURCE_SAVE_FAILURE: any = 'IMPORTSOURCE_SAVE_FAILURE';

export const IMPORTSOURCE_SAVE_MANY: any = 'IMPORTSOURCE_SAVE_MANY';
export const IMPORTSOURCE_SAVE_MANY_QUEUE: any = 'IMPORTSOURCE_SAVE_MANY_QUEUE';
export const IMPORTSOURCE_SAVE_MANY_SUCCESS: any = 'IMPORTSOURCE_SAVE_MANY_SUCCESS';
export const IMPORTSOURCE_SAVE_MANY_FAILURE: any = 'IMPORTSOURCE_SAVE_MANY_FAILURE';

export const IMPORTSOURCE_REMOVE: any = 'IMPORTSOURCE_REMOVE';
export const IMPORTSOURCE_REMOVE_QUEUE: any = 'IMPORTSOURCE_REMOVE_QUEUE';
export const IMPORTSOURCE_REMOVE_SUCCESS: any = 'IMPORTSOURCE_REMOVE_SUCCESS';
export const IMPORTSOURCE_REMOVE_FAILURE: any = 'IMPORTSOURCE_REMOVE_FAILURE';

export const IMPORTSOURCE_RESTORE: any = 'IMPORTSOURCE_RESTORE';
export const IMPORTSOURCE_RESTORE_QUEUE: any = 'IMPORTSOURCE_RESTORE_QUEUE';
export const IMPORTSOURCE_RESTORE_SUCCESS: any = 'IMPORTSOURCE_RESTORE_SUCCESS';
export const IMPORTSOURCE_RESTORE_FAILURE: any = 'IMPORTSOURCE_RESTORE_FAILURE';

export const IMPORTSOURCE_RESTORE_MANY: any = 'IMPORTSOURCE_RESTORE_MANY';
export const IMPORTSOURCE_REMOVE_MANY: any = 'IMPORTSOURCE_REMOVE_MANY';

/* Fetch actions */
export const fetchImportSourceSuccess = (importSources: ImportSource[], partial: boolean, lastFetch: number) => ({type: IMPORTSOURCE_FETCH_SUCCESS, importSources, partial, lastFetch});
export const fetchImportSourceFailure = (err: any) => {
		console.error('ImportSourceAction: fetchImportSourceFailure', err);
		return {type: IMPORTSOURCE_FETCH_FAILURE, err};
};
export const fetchOneImportSourceQueue = (importSourceId: string) => ({type: IMPORTSOURCE_FETCH_ONE_QUEUE, importSourceId});
export const fetchOneImportSourceSuccess = (importSource: ImportSource) => ({type: IMPORTSOURCE_FETCH_ONE_SUCCESS, importSource});
export const fetchOneImportSourceFailure = (id: string, err: any) => {
		console.error('ImportSourceAction: fetchOneImportSourceFailure', err);
		return {type: IMPORTSOURCE_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveImportSource = (importSource: ImportSource) => {
    // console.debug('⮂ IMPORTSOURCE_SAVE action', importSource?.id);
    return {type: IMPORTSOURCE_SAVE, importSource};
}
export const saveImportSourceQueue = (importSource: ImportSource, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ IMPORTSOURCE_SAVE_QUEUE action', importSource?.id);
    return {type: IMPORTSOURCE_SAVE_QUEUE, importSource, onQueued};
}
export const saveImportSourceSuccess = (importSource: ImportSource) => {
    // console.debug('⮂ IMPORTSOURCE_SAVE_SUCCESS action', importSource?.id);
    return {type: IMPORTSOURCE_SAVE_SUCCESS, importSource};
}
export const saveImportSourceFailure = (importSource: ImportSource, status: number, message: string) => {
    console.warn(`⮂ IMPORTSOURCE_SAVE_FAILURE error saving importSource: HTTP ${status}: ${message}`, importSource?.id);
    return {type: IMPORTSOURCE_SAVE_FAILURE, importSource, status, message};
};

/* SaveMany actions */
export const saveManyImportSources = (importSources: ImportSource[]) => {
    // console.debug('⮂ IMPORTSOURCE_SAVE_MANY action', importSources?.map(importSource => importSource?.id).join(','));
    return {type: IMPORTSOURCE_SAVE_MANY, importSources};
}
export const saveManyImportSourcesQueue = (importSources: ImportSource[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ IMPORTSOURCE_SAVE_MANY_QUEUE action', importSources?.map(importSource => importSource.id).join(','));
    return {type: IMPORTSOURCE_SAVE_MANY_QUEUE, importSources, onQueued};
}

export const saveManyImportSourcesSuccess = (importSources: ImportSource[]) => {
    // console.debug('⮂ IMPORTSOURCE_SAVE_MANY_SUCCESS action', importSources?.map(importSource => importSource.id).join(','));
    return {type: IMPORTSOURCE_SAVE_MANY_SUCCESS, importSources};
}
export const saveManyImportSourcesFailure = (importSources: ImportSource[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_IMPORTSOURCES_FAILURE Error saving importSources: HTTP ${status}: ${message}`, importSources?.map(importSource => importSource.id).join(','));
		return {type: IMPORTSOURCE_SAVE_MANY_FAILURE, importSources, status, message};
};

/* Remove actions */
export const removeImportSource = (importSource: ImportSource) => ({ type: IMPORTSOURCE_REMOVE, importSource });
export const removeImportSourceQueue = (importSource: ImportSource) => ({ type: IMPORTSOURCE_REMOVE_QUEUE, importSource });
export const removeImportSourceSuccess = (importSource: ImportSource) => ({ type: IMPORTSOURCE_REMOVE_SUCCESS, importSource });
export const removeImportSourceFailure = (importSource: ImportSource, status: number, message: string) => {
	console.error(`Redux: removeImportSourceFailure Error removing importSource: HTTP ${status}: ${message}`);
	return ({ type: IMPORTSOURCE_REMOVE_FAILURE, importSource, status, message });
};

/* Restore actions */
export const restoreImportSource = (importSource: ImportSource) => ({ type: IMPORTSOURCE_RESTORE, importSource });
export const restoreImportSourceQueue = (importSource: ImportSource) => ({ type: IMPORTSOURCE_RESTORE_QUEUE, importSource });
export const restoreImportSourceSuccess = (importSource: ImportSource) => ({ type: IMPORTSOURCE_RESTORE_SUCCESS, importSource });
export const restoreImportSourceFailure = (importSource: ImportSource, status: number, message: string) => {
	console.error(`Redux: restoreImportSourceFailure Error restoring importSource: HTTP ${status}: ${message}`);
	return ({ type: IMPORTSOURCE_RESTORE_FAILURE, importSource, status, message });
};

/* RestoreMany actions */
export const restoreManyImportSources = (importSources: ImportSource[]) => ({ type: IMPORTSOURCE_RESTORE_MANY, importSources });

/* RemoveMany actions */
export const removeManyImportSources = (importSources: ImportSource[]) => ({ type: IMPORTSOURCE_REMOVE_MANY, importSources });